export default {
	seo_meta_title_leaguepass: 'NBA | NBA ビデオと NBA ハイライト',
	seo_meta_desc_leaguepass: 'NBA ビデオでは、NBA のビデオとハイライトをお届けします。',
	seo_meta_keywords_leaguepass: 'NBA ビデオ、NBA ハイライト、バスケットボール ビデオ、トップ プレイ、ダンク、フィーチャー',
	seo_meta_title_featured: 'NBA | 特集',
	seo_meta_desc_featured: '',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA | NBA TV Live',
	seo_meta_desc_nbatv: 'NBA TV Live は 24 時間いつでもライブ中継が楽しめる NBA TV のストリーミング配信サービスです。ライブ中継に加え、毎週追加されるアーカイブ配信、スタジオ プログラム、分析コンテンツなどさまざまなコンテンツをお楽しみいただけます。',
	seo_meta_keywords_nbatv: 'NBA TV チャンネル、ザ ビート、ハードウッド クラシックス、nba ライブ、リアル nba、nba ゲームタイム、ファンタジー インサイダー、スタジオ ショー、ザ ジャンプ',
	seo_meta_title_classicgames: 'NBA | クラシックゲーム',
	seo_meta_desc_classicgames: '',
	seo_meta_keywords_classicgames: '',
	seo_meta_title_videolist: 'NBA | 動画一覧',
	seo_meta_desc_videolist: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'NBA | NBA TV番組',
	seo_meta_desc_shows: '',
	seo_meta_keywords_shows: '',
	seo_meta_title_home: 'NBA ホーム',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'NBA | チャンネル',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'NBA | チャンネル',
	seo_meta_pre_title_categories: 'NBA | カテゴリー',
	seo_meta_title_categories: 'NBA | {0}',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'NBA | カテゴリー',
	seo_meta_title_category: 'NBA | {0}',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'NBA | 動画',
	seo_meta_pre_title_event: 'NBA | イベント',
	seo_meta_title_events: 'NBA | イベント',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'NBA | イベント：{0}',
	seo_meta_desc_event: '',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'NBA | 検索',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'NBA | ページが見つかりません',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'NBA ゲーム:',
	seo_meta_title_game: 'NBA | {0}',
	seo_meta_desc_game: '',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'NBA | NBA ビデオと NBA ハイライト',
	seo_meta_desc_video: 'NBA ビデオでは、NBA のビデオとハイライトをお届けします。',
	seo_meta_keywords_video: 'NBA ビデオ、NBA ハイライト、バスケットボール ビデオ、トップ プレイ、ダンク、フィーチャー',
	seo_meta_title_channel: 'NBA | NBA TV Live',
	seo_meta_desc_channel: 'NBA TV Live は 24 時間いつでもライブ中継が楽しめる NBA TV のストリーミング配信サービスです。ライブ中継に加え、毎週追加されるアーカイブ配信、スタジオ プログラム、分析コンテンツなどさまざまなコンテンツをお楽しみいただけます。',
	seo_meta_keywords_channel: 'NBA TV チャンネル、ザ ビート、ハードウッド クラシックス、nba ライブ、リアル nba、nba ゲームタイム、ファンタジー インサイダー、スタジオ ショー、ザ ジャンプ',
	seo_meta_title_tvguide: 'NBA | NBA TV放映スケジュール',
	seo_meta_desc_tvguide: 'NBA TV Live は 24 時間いつでもライブ中継が楽しめる NBA TV のストリーミング配信サービスです。ライブ中継に加え、毎週追加されるアーカイブ配信、スタジオ プログラム、分析コンテンツなどさまざまなコンテンツをお楽しみいただけます。',
	seo_meta_keywords_tvguide: 'NBA TV チャンネル、ザ ビート、ハードウッド クラシックス、nba ライブ、リアル nba、nba ゲームタイム、ファンタジー インサイダー、スタジオ ショー、ザ ジャンプ',
	timezone: 'ET',
	default_feed_error_message: '問題が発生しました。現在コンテンツを利用できません。もう一度お試しください。',
	watch_in_app: 'NBAアプリで視聴',
	no_content: 'コンテンツがありません',
	see_more: 'もっと見る',
	now_playing: '再生中',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LPプレミアム',
	error_max_limit_favorite: 'お気に入りのビデオが上限数に達しました。ビデオを追加するにはお気に入りのビデオを削除する必要があります。',
	item_live: 'ライブ:',
	add_favourite_title: 'お気に入りに追加',
	remove_favourite_title: 'お気に入りから削除',
	p_channel_live: 'ライブ:',
	p_channel_schedule_title: 'NBA TV放映スケジュール',
	p_channel_schedule_watch: '視聴する',
	p_channel_schedule_no_date: '現在放映スケジュールがありません。',
	p_channel_live24x7_title: 'NBA TV 24/7',
	p_channel_live24x7_see_full_schedule: 'すべての放映スケジュールを見る',
	p_channel_live24x7_up_next: 'up next',
	p_channel_live24x7_on_demand: 'NBA TV：オンデマンド',
	p_channel_live24x7_collection: 'コレクション',
	p_channel_live24x7_demand_1_logo_text: 'オリジナル番組',
	p_channel_live24x7_demand_1_show_name: 'NBA TV番組',
	p_channel_live24x7_demand_1_show_desc: '「Shaqtin’ a Fool」、「Beyond the Paint」、「Game Time」、「Basketball Stories」などのNBA TVオリジナル番組',
	p_channel_live24x7_demand_2_logo_text: 'クラシックゲーム',
	p_channel_live24x7_demand_2_show_name: 'NBA | クラシックゲーム',
	p_channel_live24x7_demand_2_show_desc: '2000年以降のファイナル全試合、リーグの歴史的瞬間、NBAレジェンドなど、過去の名勝負を完全版で配信',
	p_channel_clips_title: 'NBA TVクリップ',
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'スケジュール',
	p_nba_tv_shows: 'NBA TV番組',
	p_nba_tv_no_access_title: '24/7 NBA：ゲーム分析、スタジオ解説、オリジナル番組など情報が盛りだくさん！',
	p_nba_tv_no_access_desc: '試合のライブ配信、オンデマンドの番組とクラシックゲームを視聴。',
	p_nba_tv_no_access_note: 'ブラックアウトが適用される場合があります',
	tv_show_item_latest_episode: '最新のエピソード',
	tv_show_item_no_latest_episode: '最新のエピソードはありません',
	see_all: 'すべて表示',
	header_menu_watch: '視聴する',
	header_menu_featured: 'ピックアップ',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',
	players: '選手',
	videos: 'ビデオ',
	teams: 'チーム',
	most_searched: '検索数トップ',
	no_result: 'データがありません',
	search_filter_type_most_relevant: '関連順',
	search_filter_type_most_viewed: '視聴順',
	search_filter_type_most_recent: '日付順',
	search_filter_type_last_30_days: '過去30日間',
	search_filter_type_last_6_months: '過去6ヶ月間',
	search_result_label: '「{keyword}」の検索結果',
	search_result_info: '「{keyword}」の検索結果をすべて表示',
	search_placeholder: '動画ライブラリを検索',
	load_more: 'もっと読み込む...',
	button_subscribe: '申し込む',
	button_sign_in: 'サインイン',
	p_league_pass_no_access_title: 'コンピューターやスマートフォン、テレビなど、お好きなデバイスからライブまたはリピート再生で視聴！',
	p_league_pass_no_access_desc: 'アクションへの招待状：リーグ全体やお気に入りのチームを視聴、シングルゲームを選択、他にもオプション多数。',
	p_league_pass_no_access_note: '利用規約が適用されます',
	category_title: 'ビデオ',
	p_video_playlist_title: 'プレイリスト:',
	p_no_access_league_pass_title: '視聴するには、NBA League Passのサブスクリプションを購入してください。',
	p_no_access_league_pass_desc: 'アクションへの招待状：リーグ全体やお気に入りのチームを視聴、シングルゲームを選択、他にもオプション多数。',
	p_no_access_league_pass_terms: '利用規約が適用されます',
	p_no_access_league_pass_geo_desc: 'あなたの現在位置からはNBA League PassとNBA TVでこの試合を視聴できません。NBA League Passをご利用の方は、放送から3日後にアーカイブから視聴することができます。お住まいの地域での放送を確認するには、テレビおよびラジオ放送局のスケジュールをご覧ください。',
	p_no_access_league_pass_not_found_desc: '申し訳ありません。お探しの動画が見つかりませんでした。',
	p_no_access_event_not_found_desc: '申し訳ありません。お探しのイベントが見つかりませんでした。',
	p_no_access_nba_tv_title: '視聴するには、NBA TVのサブスクリプションを購入してください。',
	p_no_access_nba_tv_desc: '試合のライブ配信、オンデマンドの番組とクラシックゲームを視聴。',
	p_no_access_nba_tv_terms: '利用規約が適用されます',
	p_no_access_nba_tv_geo_desc: 'あなたの現在位置からはNBA League PassとNBA TVでこの試合を視聴できません。NBA League Passをご利用の方は、放送から3日後にアーカイブから視聴することができます。お住まいの地域での放送を確認するには、テレビおよびラジオ放送局のスケジュールをご覧ください。',
	p_no_access_nba_tv_not_found_desc: '申し訳ありません。お探しのチャンネルが見つかりませんでした。',
	p_no_access_up_next: 'Up Next：',
	p_video_completed_title: 'プレイリストが完了しました',
	p_video_completed_desc: '戻ってブラウズするか、次のプレイリストをチェックしてください',
	p_video_share_to: '共有先：',
	p_video_more_to_watch: 'こちらもおすすめ：',
	p_event_section_title: 'イベント',
	p_event_playlist_title: 'プレイリスト:',
	p_event_button_watch: '視聴する',
	p_event_button_listen: '聞く',
	p_event_button_ticket: 'チケット',
	notfound: '要求されたページは見つかりませんでした。',
	notfound_desc: 'URL に誤りがないか確認してください。 <br/>サイト ナビゲーションまたは検索ツールを使って、お探しのコンテンツを見つけることもできます。',
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'NBA League Passアカウントがストリーミング上限に達しました。このデバイスで視聴を続けるには、「続ける」をタップしてください。',
	modal_pcm_custom: '続ける',
	modal_pcm_close: 'キャンセル',
	modal_adobe_concurrency_header_title: '動画との接続が切断されました',
	modal_adobe_concurrency_body_title: '',
	modal_adobe_concurrency_body_description: 'ストリーミングは終了しました。同時ストリーミング数の制限に達した、ネットワークが切断された、技術的なエラーが発生したなどの原因が考えられます。続けるには、ログインし直して、チャンネルを選択してください。',
	modal_adobe_concurrency_close: '完了',
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'この動画は、お使いのデバイスでは再生できません。お困りでしたら、<a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>こちら</a>をクリックしてください。',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'オクラホマ州',
	freesample_notice_time: '残り時間',
	freesample_notice_title: 'アクセス時間{0}分をお楽しみください。',
	freesample_notice_desc: '{0}分終了後も、コンテンツへのアクセスを継続するためにLeague Passのフルパッケージを購読してください。',
	freesample_notice_subscribe_button: '申し込む',
	freesample_notice_cancel_button: 'いつでもキャンセル',
	freesample_popup_title: 'アクセス時間が終了しました',
	freesample_popup_subtitle: 'League Passに登録して、さらに多くの偉大なNBAのコンテンツを見ましょう。',
	freesample_popup_link: '詳しい情報をご覧ください！',
	freesample_popup_get_minutes_button: '{0} 分ゲット',
	reg_required_desc: 'このコンテンツを視聴するには、ログインする必要があります',
	favorite_teams_title: 'お気に入りのチーム',
	bookmarked_title: '保存しました',
	watch_history_title: '視聴を続ける',
	game_schedule_title: 'ゲームのスケジュール',
	recommended_title: 'おすすめ',
	season_text: 'シーズン',
	section_tv_provider_title: 'テレビプロバイダーの管理',
	section_tv_provider_desc: 'ご契約のテレビプロバイダーを経由して、試合のライブ配信やストリーミング配信にアクセスできます。',
	section_tv_provider_faq: 'テレビプロバイダーのよくあるご質問',
	section_tv_provider_sign_out: 'サインアウト',
	header_menu_account_my_account: 'マイ アカウント',
	header_menu_account_manage_account: 'アカウントの管理',
	header_menu_account_favorite_teams: 'お気に入りのチーム',
	header_menu_account_favorite_players: 'お気に入りの選手',
	header_menu_account_viewing_history: '視聴履歴',
};
